import React, {Component} from "react";
import {
    Col,
    Row,
	InputGroup,
	InputGroupAddon,
    Input
} from "reactstrap";

import Registry from "../../Utils/Registry";
import TYPagination from "../TYPagination";
import { NotificationManager } from "react-notifications";
import EnterpriseInvoicesTable from "./Invoices/InvoicesTable";
import TYDatePicker from "../TYDatePicker";
import TYDropDown, { TYDropDownItem } from "../TYDropDown";
import Helpers from "../../Utils/Helpers";


class EnterpriseInvoices extends Component {
    constructor(props) {
        super(props);

        this.api = Registry.registered("api");

        this.state = {
            loading: false,
            invoices: [],
            per_page: 8,
            page: 1,
            total_pages: 1,
            invoicesSelected: [],
            showFilters: false,
            filters: {}
        };
    }

    componentDidMount() {
        this.user = Registry.observe(this, "user", user => {
            this.user = user;
			this.loadInvoices();
        });
        if(this.user)
            this.loadInvoices();
    }

    changePage = (page) => {
        this.loadInvoices(page);
    };

    loadInvoices = (page) => {
        this.setState({
            loading: true,
            invoices: []
        });

        if(!this.user){
            NotificationManager.error("Impossible de générer les factures");
            return;
        }

        let businessId = this.user.business_id;

        let url = "/orders/invoices/business/" + businessId + "?order_by_desc=number&page=" + page;
        for(let k in this.state.filters){
            if(this.state.filters.hasOwnProperty(k) && this.state.filters[k] !== "null")
                url += "&" + k + "=" + this.state.filters[k];
        }

        this.api.get(url)
            .then(results => {
                this.setState({
                    loading: false,
                    invoices: results.results,
                    per_page: results.per_page,
                    page: results.page,
                    total_pages: results.total_pages
                });
            })
            .catch(() => {
                NotificationManager.error("Impossible de charger les factures");
                this.setState({ loading: false });
            });
    };

    _invoicesSelected = invoices => {
        let qbIds = "";
        for (let i = 0; i < invoices.length; i++) {
            qbIds += invoices[i].number;
            if (i !== invoices.length -1) {
                qbIds += ",";
            }
        }
        this.setState({invoicesSelected: qbIds});
    };

    downloadInvoices = () => {
        if (this.state.invoicesSelected.length === 0)
            NotificationManager.error("Veuillez selectionner au moins une facture");
        else{
            let url = "?invoices_numbers=" + this.state.invoicesSelected + "&user_id=" + this.user.business_id + "&is_business=1";
            this.api
                .download("/orders/invoices/download" + url, 'tankyou-factures')
                .catch(error => {
                    NotificationManager.error("Impossible de recuperer les factures");
                });
        }
    };

	toggleFilters = () => {
        this.setState({
            showFilters: !this.state.showFilters,
            filters: {}
        }, () => {
            if(!this.state.showFilters)
                this.loadInvoices();
        });
    };

    setFilter = (key, value) => {
        let filters = this.state.filters;
        filters[key] = value;
        this.setState({filters, filters}, this.loadInvoices);
    };

    render() {
        return (
            <Row>
                <Col xs="12" sm="12" lg="12" xl="8">
                    <div className="d-flex justify-content-between marg-b-20">
    					<h2 className="ty-subtitle align-self-center">Vos factures</h2>
                        <h3></h3>
                    </div>
                    <div className="table-filters-line">
                        <div className="table-filter-search">
							<InputGroup>
								<Input
									placeholder="Num de commande ou de facture, .."
									className="no-focus advanced-search-input"
                                    value={this.state.filters.id}
                                    onChange={e => { this.setFilter('id', e.target.value); }}
								/>
								<InputGroupAddon className="advanced-search-filter" onClick={this.toggleFilters} addonType="append">
									<div style={{marginTop: '13px', paddingRight: '10px'}}>{this.state.advanced_search ? "Fermer" : "Filtres"}</div>
								</InputGroupAddon>
							</InputGroup>
                        </div>

						<div className={"table-filter-massaction"}>
                            {
                                this.state.invoicesSelected.length ?
                                    <TYDropDown label="S&eacute;l&eacute;ctionner une action">
                                        <TYDropDownItem onClick={this.downloadInvoices}>Télécharger</TYDropDownItem>
                                    </TYDropDown>
                                    : null
                            }
                        </div>

						<div className="table-filter-pagination">
							<TYPagination
								page={this.state.page}
								total_pages={this.state.total_pages}
								onPageChanged={this.changePage}
							/>
                        </div>
                    </div>

                    {
                        this.state.showFilters ?
                            <div className="advanced-filter-container">
								<div className="advanced-filter">
									<div className="advanced-filter-label">Date</div>
									<div className="flex-line">
                                        <TYDatePicker onDatePicked={date => { this.setFilter('date_min', Helpers.formatDate(date, 'YYYY-MM-DD')); }} />
										<div className="flex-centered pad-10">au</div>
                                        <TYDatePicker onDatePicked={date => { this.setFilter('date_max', Helpers.formatDate(date, 'YYYY-MM-DD')); }} />
									</div>
								</div>
								<div className="advanced-filter">
									<div className="advanced-filter-label">Paiement</div>
									<div className="flex-line">
										<select className="form-control" onChange={(e) => { this.setFilter('paid', e.target.value); }}>
                                            <option value="null">S&eacute;l&eacute;ctionner ...</option>
                                            <option value={0}>Non pay&eacute;e</option>
                                            <option value={4}>En attente de paiement</option>
											<option value={2}>En cours de paiement</option>
                                            <option value={1}>Payée</option>
											<option value={3}>Default de paiement</option>
                                        </select>
									</div>
								</div>
                            </div>
                            : null
                    }

                    <EnterpriseInvoicesTable
                        loading={this.state.loading}
                        invoices={this.state.invoices}
                        doMultiSelect={this.state.doMultiSelect}
                        onInvoicesSelected={this._invoicesSelected}
                    />
                </Col>
            </Row>
        )
    }
}

EnterpriseInvoices.defaultProps = {
    // doMultiSelect: false
};

export default EnterpriseInvoices;



// WEBPACK FOOTER //
// ./src/components/Enterprise/Invoices.js